import { render, staticRenderFns } from "./ReferenceCaseDetails.vue?vue&type=template&id=e1fa6aaa"
import script from "./ReferenceCaseDetails.vue?vue&type=script&lang=js"
export * from "./ReferenceCaseDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports